import { getAddress } from "@ethersproject/address";
import memoize from "lodash/memoize";
import { ChainId, Token } from "@pancakeswap/sdk";

const mapping = {
  [ChainId.BSC]: "smartchain",
  [ChainId.ETHEREUM]: "ethereum",
  [ChainId.MANTLE_TESTNET]: "mantle",
  [ChainId.MANTLE]: "mantle",
  [ChainId.FIVEIRE]: "fiveire",
};

const getTokenLogoURL = memoize(
  (token?: Token) => {
    if (token && mapping[token.chainId]) {
      console.log(token);
      console.log(mapping[token.chainId]);
      /* return `https://assets-cdn.trustwallet.com/blockchains/${
        mapping[token.chainId]
      }/assets/${getAddress(token.address)}/logo.png`; */
      return `${token?.projectLink}`;
    }
    return null;
  },
  (t) => `${t.chainId}#${t.address}`
);

export const getTokenLogoURLByAddress = memoize(
  (address?: string, chainId?: number) => {
    if (address && chainId && mapping[chainId]) {
      console.log(mapping[chainId]);
      return `https://assets-cdn.trustwallet.com/blockchains/${
        mapping[chainId]
      }/assets/${getAddress(address)}/logo.png`;
    }
    return null;
  },
  (address, chainId) => `${chainId}#${address}`
);

export default getTokenLogoURL;
